const ANONYMOUS_PATH_PREFIXES = [
  '/inloggen',
  '/gegevensdelen',
  '/geenlogin',
  '/registreren',
  '/aanmelden',
  '/accountregistration',
  '/succesvolgeregistreerd',
  '/registrerensucces',
  '/ssosignout',
  '/koppeling'
];

export function isAnonymousPage(pathname = window.location.pathname) {
  return ANONYMOUS_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
